const prepare = (s: string) => s
    .toLowerCase()
    .replace(/ /g, '')
export default (value: string, search: string) => prepare(value).includes(prepare(search))
